<template>
    <div class="clause">
        <div class="container">
            <breadcrumbs :dom="crumbsItem" />
            <div class="text-center">
                <h3>服務條款</h3>
            </div>
            <div class="htmltext" v-html="policy.Content"></div>
        </div>
    </div>
</template>

<script>
    import Breadcrumbs from '@/components/partial/Breadcrumbs'
    import policyApi from '@/api/policy'

    export default {
        data() {
            return {
                crumbsItem: [{
                        text: '首頁',
                        to: {
                            name: 'home'
                        },
                    },
                    {
                        text: '服務條款',
                        active: true
                    }
                ],
                policy: [],
            }
        },
        components: {
            Breadcrumbs,
        },
        methods: {
            createMetaTag() {
                // Create new meta tags
                const metaImage = document.createElement('meta');
                metaImage.setAttribute('property', 'og:image');
                metaImage.setAttribute('content', 'https://cdn.hola.com.tw/_ui/responsive/theme-trplus/app/images/mobile/index/hola-2023-revision-og.png?1692747001000');
                document.head.appendChild(metaImage);

                const metaTitle = document.createElement('meta');
                metaTitle.setAttribute('property', 'og:title');
                metaTitle.setAttribute('content', 'HOLA 和樂家居｜生活學 – 服務條款');
                document.head.appendChild(metaTitle);

                const metaDescription = document.createElement('meta');
                metaDescription.setAttribute('property', 'og:description');
                metaDescription.setAttribute('content', 'HOLA竭力遵守會員服務條款與隱私權政策，重視每位顧客跟使用者的隱私權並遵守個人資料保護相關法令規定、蒐集、處理、利用與保護你的個人資料');
                document.head.appendChild(metaDescription);
            },
        },
        created() {
            policyApi.policyType((data) => {
                this.policy = data ? data : []
            });
            this.createMetaTag();
        },
        destroyed() {
            const metaTags = document.querySelectorAll('meta[property^="og:"]');
                metaTags.forEach((metaTag) => {
                metaTag.parentNode.removeChild(metaTag);
            });
        }
    }
</script>
